import { BASE_URL } from "./userConstant";

//form-template-data
export const FORM_TEMPLATE_DATA = `${BASE_URL}/Home/GetFormTemplateJson`;

//save-template-data
export const SAVE_FORM_DATA = `${BASE_URL}/Home/SaveFormTemplateJson`;

//save user-editable question label
export const SAVE_USER_QUESTION_LABEL = `${BASE_URL}/Home/SaveUserQuestionLabel`;

// Authentication Endpoints
export const LOGIN_ENDPOINT = `${BASE_URL}/Account/Login`;
export const SIGNUP_ENDPOINT = `${BASE_URL}/Account/SignUp`;
export const EMAIL_VERIFICATION_ENDPOINT = `${BASE_URL}/Account/Email/Verify`;
export const VERIFY_EMAIL = `${BASE_URL}/Account/Email/Exists`;
export const FORGET_PASSWORD = `${BASE_URL}/Account/ForgetPassword`;
export const RESEND_EMAIL = `${BASE_URL}/Account/Email/Verify/Resend`;
export const SEND_SIGNUP_OTP = `${BASE_URL}/Account/Otp/Send`;
export const VERIFY_SIGNUP_OTP = `${BASE_URL}/Account/Verify/Otp`;
export const RESEND_SIGNUP_OTP = `${BASE_URL}/Account/Resend/Otp`;

//Product Detail Endpoints
export const PRODUCT_DETAIL = `${BASE_URL}/Book/Detail`

//Dashboard
export const DASHBOARD_DETAIL = `${BASE_URL}/Home/Dashboard`

//Book Info
export const SAVE_BOOK_INFO = `${BASE_URL}/Home/SaveBookInfo`;
export const ALL_BOOKS = `${BASE_URL}/Home/Index`
export const GET_BOOK_INFO = `${BASE_URL}/Home/GetBookInfo`
export const ADD_TO_CART = `${BASE_URL}/Cart/Cart`
export const HIDE_DOUBLE_PAGE_SPREAD = `${BASE_URL}/Home/ToggleBookPageDoubleView`

//cart
export const GET_CART_DETAILS = `${BASE_URL}/Cart/Cart`

//order
export const CREATE_ORDER = `${BASE_URL}/Order`

// Reset Password
export const TOKEN_VERIFY = `${BASE_URL}/Account/ResetPassword/Get`
export const POST_RESET_PASSWORD = `${BASE_URL}/Account/ResetPassword/Submit`

// Book Cover
export const GET_BOOK_COVER = `${BASE_URL}/Book/Cover/Page`
export const POST_BOOK_COVER = `${BASE_URL}/Book/Cover/Page`


//Stripe
export const GET_PAYMENT_METHODS = `${BASE_URL}/Payment/method`
export const CREATE_PAYMENT = `${BASE_URL}/Payment/CreateNewStripePayment`
export const DELETE_PAYMENT_METHOD = `${BASE_URL}/Payment/method/remove`

//Image Data
//export const IMAGE_UPLOAD = `${BASE_URL}/Book/file/upload`
export const IMAGE_UPLOAD = `${BASE_URL}/Book/presigned-urls/upload`
export const IMAGE_GET_DATA = `${BASE_URL}/Book/file`



//PreviewBook
export const BOOK_PAGES = `${BASE_URL}/Book/Pages`

//Blogs
export const BLOGS_PAGES = `${BASE_URL}/Blog`

//PDF
export const SAVE_PDF = `${BASE_URL}/Book/save-pdf`

//voucher
export const COUPONS_LIST = `${BASE_URL}/Voucher/CouponsList`
export const BUY_VOUCHER = `${BASE_URL}/Voucher/Buy`
export const GET_VOUCHER = `${BASE_URL}/Voucher`
export const APPLY_PROMO_CODE = `${BASE_URL}/Order/PromoCodeDetail`

//save book page preview
export const SAVE_BOOK_PAGE_PREVIEW = `${BASE_URL}/Book/Page/Preview`

//contactus
export const CONTACT_US = `${BASE_URL}/CmsPages/contactus`

//CMS
export const CMS_PAGES = `${BASE_URL}/CmsPages`

// faq page details
export const FAQ_DETAIL = `${BASE_URL}/CmsPages/faq`

//manageAccounts
export const GET_NOTIFICATION_INFO = `${BASE_URL}/Account/GetNotificationInfo`
export const SAVE_NOTIFICATION_INFO = `${BASE_URL}/Account/SaveNotificationInfo`
export const CHANGE_PASSWORD = `${BASE_URL}/Account/ChangePassword`
export const GET_PROFILE_INFO = `${BASE_URL}/Account/GetProfileInfo`
export const SAVE_PROFILE_INFO = `${BASE_URL}/Account/SaveProfileInfo`
export const GET_SHIPPING_INFO = `${BASE_URL}/Account/GetShippingInfo`
export const SAVE_SHIPPING_INFO = `${BASE_URL}/Account/SaveShippingInfo`

// NewsLetter Subscription 
export const SUBSCRIBE_NEWSLETTER = `${BASE_URL}/Account/NewsLetter`;
export const UNSUBSCRIBE_NEWSLETTER = `${BASE_URL}/Account/UnSubscribeNewsLetter`;

//Order Book
export const GET_ORDER_PRINT_REQUEST = `${BASE_URL}/Order/GetOrderPrintRequest`;
export const CONFIRM_AND_PRINT = `${BASE_URL}/Order/ConfirmPrint`;

//Send Invitation
export const SEND_PAGE_INVITE = `${BASE_URL}/Home/SendPageInvite`;
export const GET_INVITEES_LIST = `${BASE_URL}/Home/PageInviteList`;
export const DELETE_INVITEE = `${BASE_URL}/Home/DeletePageInvite`;
export const VERIFY_TOKEN = `${BASE_URL}/PageInvite/PageInvite/verify-token`;
export const VERIFY_OTP = `${BASE_URL}/PageInvite/PageInvite/verify-otp`;
export const ADD_MESSAGE = `${BASE_URL}/PageInvite/book/SaveNotes`;
export const GET_GUEST_DATA = `${BASE_URL}/PageInvite/book/SaveNotes`;
export const RESEND_OTP = `${BASE_URL}/PageInvite/PageInvite/send-otp`;

//Order History
export const GET_ORDER_HISTORY = `${BASE_URL}/Orders`;
export const GET_ORDER_DETAILS = `${BASE_URL}/Order`;
export const DOWNLOAD_INVOICE = `${BASE_URL}/Order/DownloadInvoice`;
export const PRINT_ORDER_LIST = `${BASE_URL}/PrintRequest/PrintRequestList`;

// Announcement bar (public, logged-out users)
export const ANNOUNCEMENT = `${BASE_URL}/Announcement`;


